module.exports = __webpack_public_path__ + "static/assets/c32161f63de4e9461f94f8a101011b9a.jpg";